import React from 'react'

import ProgressBar from 'common/ProgressBar'
import {init} from 'MessageBundle'
import conf from 'configuration.json'
import BaseComponent from "common/BaseComponent";

export const Role = {
    ANONYMOUS: 0,
    SALES_PARTNER: 1,
    VPQ_OPERATOR: 2,
    ADMIN: 3
};

export class BaseDialog extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            initialized: false
        }

        document.title = props.title;
    }

    /**
     * Initialize method is used to load context. It has to be invoked from `componentDidMount` function of a parent component.
     * @param callback function that has to be executed after context loading.
     */
    init(callback) {
        this.request('get', conf.rest.contextEndpoint).send((result) => {
            init(result.body.messages);
            this.setState({
                logoutTimeout: result.body.logoutTimeout * 1000,
                tvppReturnUrl: result.body.tvppReturnUrl,
                tvppLogoutUrl: result.body.tvppLogoutUrl,
                statusRedirectUrl: result.body.statusRedirectUrl,
                vo: result.body.vo,
                email: result.body.email,
                vpqOperator: result.body.vpqOperator,
                complaintTypes: result.body.complaintTypes,
                salesManager: result.body.salesManager,
                accountName: result.body.accountName,
                admin: result.body.admin
            }, this.checkRoles(() => {
                if (callback !== undefined){
                    callback();
                } else {
                    this.setState({initialized: true})
                }
            }));
        });
    }

    checkRoles = (roleAllowedCallback) => () => {
        const userRoles = this.calculateRoles(this.state);
        const foundRoles = this.getAllowedRoles().filter(role => userRoles.includes(role));
        if (foundRoles.length === 0) {
            window.location.href = this.state.tvppRedirectRequired ? this.state.statusRedirectUrl : '/';
        } else {
            roleAllowedCallback();
        }
    };

    calculateRoles({vo, vpqOperator, admin}){
        let result = [Role.ANONYMOUS];
        if (vo !== undefined) {
            result.push(Role.SALES_PARTNER);
        }
        if(vpqOperator) {
            result.push(Role.VPQ_OPERATOR);
        }
        if(admin) {
            result.push(Role.ADMIN);
        }
        return result;
    }

    /**
     * Returns <ProgressBar/> if the dialog is not initialized yet, otherwise returns the dialog content.
     * initialized = true has to be defined in a parent class.
     * @returns progress bar or dialog content.
     */
    render() {
        let dialog;
        if (!this.state.initialized) {
            dialog = <ProgressBar/>;
        } else {
            dialog = this.getDialog();
        }
        return dialog;
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/BaseDialog.js